import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  useAuthUserRestaurant,
  useGetSingleRestaurantCompanyLocationQuery,
  useGetSingleRestaurantCompanyLocationEmployeesQuery,
} from '@durma-soft/gros-sdk';

import { CompanyEmployeesPage } from '@/components/restaurant/companies/company-employees-page';

import { useTableSearchParams } from '@/hooks/use-table-search-params';

const RestaurantCompanyLocationEmployees = () => {
  const { t } = useTranslation();
  const { companyId, locationId, employeeId } = useParams();

  if (!companyId || !locationId) {
    throw new Error('Company and location IDs are required getting employees');
  }

  const restaurant = useAuthUserRestaurant();
  const state = useTableSearchParams({ prefix: 'e_' });

  const { data: location } = useGetSingleRestaurantCompanyLocationQuery({
    restaurant_id: restaurant.id,
    company_id: Number(companyId),
    location_id: Number(locationId),
  });

  const query = useGetSingleRestaurantCompanyLocationEmployeesQuery({
    restaurant_id: restaurant.id,
    company_id: Number(companyId),
    location_id: Number(locationId),
    q: state.debouncedSearchInput,
    page: state.pagination.pageIndex + 1,
    page_size: state.pagination.pageSize,
    sort_by: state.sorting[0]?.id,
    sort_order: state.sorting[0]?.desc ? 'desc' : 'asc',
  });

  return (
    <CompanyEmployeesPage
      companyId={Number(companyId)}
      employeeId={employeeId}
      breadcrumbItems={[
        {
          label: location?.name
            ? `${t('employee.title')} (${location.name})`
            : t('employee.title'),
          to: `/restaurant/companies/${companyId}/locations/${locationId}/employees`,
        },
      ]}
      createTo={`/restaurant/companies/${companyId}/locations/${locationId}/employees/create`}
      importTo={`/restaurant/companies/${companyId}/locations/${locationId}/employees/import`}
      query={query}
      state={state}
    />
  );
};

export default RestaurantCompanyLocationEmployees;
